"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    props: {
        value: String
    },
    data: function () {
        return this.parseFileName(this.value);
    },
    methods: {
        parseFileName: function (fileName) {
            var parts = fileName.split('.');
            return {
                fileNameWithoutExtension: parts.slice(0, -1).join('.'),
                extension: '.' + parts.pop(),
            };
        }
    },
    watch: {
        value: function (value) {
            var parsed = this.parseFileName(value);
            this.fileNameWithoutExtension = parsed.fileNameWithoutExtension;
            this.extension = parsed.extension;
        },
        fileNameWithoutExtension: function (value) {
            this.$emit('input', value + this.extension);
        }
    }
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./_wwwsrc/js/Workflow/Components/Input/FileNameEditor.vue
// module id = 180
// module chunks = 0